// src/components/Layout/Footer.tsx
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  Divider,
  IconButton
} from '@mui/material';
import {
  GitHub,
  Twitter,
  LinkedIn,
  YouTube,
} from '@mui/icons-material';

interface FooterSection {
  title: string;
  links: Array<{
    text: string;
    href: string;
    onClick?: (e: React.MouseEvent) => void;
  }>;
}
// const handleNewsletterSubmit = (e: React.FormEvent) => {
//   e.preventDefault();
// };

const handleContactClick = (e: React.MouseEvent) => {
  e.preventDefault();
  window.location.href = 'mailto:support@qixbi.com';
};

const handleAboutClick = (e: React.MouseEvent) => {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const footerSections: FooterSection[] = [
  {
    title: 'Products',
    links: [
      { text: 'QixDeploy', href: 'https://qixdeploy.com' },
      { text: 'QixScreener', href: '/products/qixscreener' },
      // { text: 'Download', href: '/download' },
      // { text: 'Pricing', href: '/pricing' },
      // { text: 'What\'s New', href: '/updates' }
    ]
  },
  // {
  //   title: 'Solutions',
  //   links: [
  //     { text: 'Enterprise', href: '/solutions/enterprise' },
  //     { text: 'Startups', href: '/solutions/startups' },
  //     { text: 'Teams', href: '/solutions/teams' },
  //     { text: 'Education', href: '/solutions/education' },
  //     { text: 'Industries', href: '/solutions/industries' }
  //   ]
  // },
  // {
  //   title: 'Resources',
  //   links: [
  //     { text: 'Documentation', href: '/docs' },
  //     { text: 'API Reference', href: '/api' },
  //     { text: 'Blog', href: '/blog' },
  //     { text: 'Community', href: '/community' },
  //     { text: 'Support', href: '/support' }
  //   ]
  // },
  {
    title: 'Company',
    links: [
      { text: 'About Us', href: '#', onClick: handleAboutClick },
      { text: 'Contact', href: '#', onClick: handleContactClick },
      //{ text: 'Partners', href: '/partners' },
      { text: 'Legal', href: '/legal' }
    ]
  }
];

const socialLinks = [
  { icon: <GitHub />, href: 'https://github.com/qixbi' },
  { icon: <Twitter />, href: 'https://twitter.com/qixbi' },
  { icon: <LinkedIn />, href: 'https://linkedin.com/company/qixbi' },
  { icon: <YouTube />, href: 'https://youtube.com/qixbi' }
];

export const Footer: React.FC = () => {
  

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 8,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        {/* Main Footer Content */}
        <Grid container spacing={4}>
          {/* Newsletter Section */}
          <Grid item xs={12} md={4}>
            {/* <Typography variant="h6" gutterBottom>
              Stay Updated
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Subscribe to our newsletter for the latest updates, releases, and developer news.
            </Typography>
            <Box
              component="form"
              onSubmit={handleNewsletterSubmit}
              sx={{
                display: 'flex',
                gap: 1,
                mb: 4
              }}
            >
              <TextField
                size="small"
                placeholder="Enter your email"
                variant="outlined"
                sx={{ flexGrow: 1 }}
              />
              <Button
                type="submit"
                variant="contained"
                sx={{ minWidth: 'auto' }}
              >
                <ArrowForward />
              </Button>
            </Box> */}

            {/* Social Links */}
            <Stack direction="row" spacing={1}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: 'text.secondary',
                    '&:hover': {
                      color: 'primary.main'
                    }
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
        
            </Stack>
            <Typography variant="body2" color="text.secondary" paragraph>Contact us at : support@qixbi.com</Typography>
          </Grid>

          {/* Footer Sections */}
          {footerSections.map((section) => (
          <Grid item xs={6} sm={3} md={2} key={section.title}>
            <Typography
              variant="subtitle2"
              color="text.primary"
              sx={{ fontWeight: 'bold', mb: 2 }}
            >
              {section.title}
            </Typography>
            <Stack spacing={1}>
              {section.links.map((link) => (
                <Link
                  key={link.text}
                  href={link.href}
                  onClick={link.onClick}  // Add onClick handler
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'primary.main',
                      textDecoration: 'none'
                    }
                  }}
                >
                  {link.text}
                </Link>
              ))}
            </Stack>
          </Grid>
        ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Bottom Footer */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Qixbi. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={3}>
            <Link
              href="/privacy"
              variant="body2"
              color="text.secondary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  color: 'primary.main'
                }
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              variant="body2"
              color="text.secondary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  color: 'primary.main'
                }
              }}
            >
              Terms of Service
            </Link>
            <Link
              href="/sitemap"
              variant="body2"
              color="text.secondary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  color: 'primary.main'
                }
              }}
            >
              Sitemap
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};